import { INITIAL_STATE } from './constants'

export default {
  ...INITIAL_STATE
}
